import { Button, Header, Segment } from "semantic-ui-react";

import React from "react";

import { languageName } from "astrid-helpers/src/languages";

import Flex from "../../../../../components/Flex/Flex";
import CoverImageStack from "../../../../ui/components/CoverImage/CoverImageStack";

export default function CreateProductionWorkListItem({ work, onClick }) {
	return (
		<Segment>
			<Flex alignItems="center" justifyContent="flex-start">
				<div style={{ marginRight: "1em", height: 45, width: 45 }}>
					<CoverImageStack data={work} size={45} style={{ margin: "0 auto" }} />
				</div>

				<div>
					<Header as="h5" style={{ margin: 0 }}>
						{work.name}
					</Header>

					<div style={{ opacity: 0.4, fontSize: "0.9em" }}>{languageName(work.language)}</div>
				</div>
			</Flex>

			<Button
				basic
				circular
				icon="minus"
				style={{
					height: 28,
					width: 28,
					padding: 0,
					position: "absolute",
					right: 15,
					top: 20,
				}}
				onClick={onClick}
			/>
		</Segment>
	);
}
